<template lang="pug">
  LoaderOverlay(:loading="loading")
    form
      .row
        .col-md-6
          .form-group
            Label(text="Slug")
            Input(v-model="issue.slug")
          .form-group
            Label(text="Title")
            Input(v-model="issue.title")

        .col-md-6
          PublicationField(v-model="issue.publication.id" :required="true")
          SubsiteField(:publication-id="issue.publication.id" v-model="issue.subsite_id")

          .form-group
            Label(text="Publish Date")
            DateField(v-model="issue.publish_on")

      .row
        .col-md-12
          .form-group
            Label(text="Notes")
            TextareaInput(v-model="issue.notes")

      .row
        .col-md-12
          button.btn.btn-primary(@click.prevent="save") Save
          router-link.btn.btn-link.text-muted(to="/issues/") cancel
</template>

<script>
  import { mapStores, mapState } from 'pinia'
  import { isEmpty } from 'lodash'
  import { useIssueStore } from '@/stores/issue'
  import { usePublicationsStore } from '@/stores/publications'
  import { useSubsitesStore } from '@/stores/subsites'

  import DateField from '@/components/shared/date_field.vue'
  import Input from '@/components/shared/input.vue'
  import Label from '@/components/shared/label.vue'
  import LoaderOverlay from '@/components/shared/loader_overlay.vue'
  import PublicationField from '@/components/shared/publication_field.vue'
  import SubsiteField from '@/components/shared/subsite_field.vue'
  import TextareaInput from '@/components/shared/textarea_input.vue'

  export default {
    components: {
      DateField,
      Input,
      Label,
      LoaderOverlay,
      PublicationField,
      SubsiteField,
      TextareaInput
    },

    props: {
      saveAction: {
        type: String,
        default: 'save',
        options: ['save', 'clone']
      }
    },

    data() {
      return {
        loading: false
      }
    },

    computed: {
      ...mapStores(useIssueStore, usePublicationsStore, useSubsitesStore),
      ...mapState(useIssueStore, ['issue']),

      subsiteOptions() {
        if (!this.issue.publication.id) return {}

        return this.subsitesStore.forPublicationAsObject({ publicationId: this.issue.publication.id })
      },

      showSubsiteField() {
        return !isEmpty(this.subsiteOptions)
      }
    },

    async mounted() {
      this.publicationsStore.$reset()
      this.subsitesStore.$reset()
      this.issueStore.$reset()

      await this.subsitesStore.fetchOnce()
    },

    methods: {
      async save() {
        this.loading = true

        this.issueStore[this.saveAction]().then(({ id }) => {
          this.loading = false
          this.$router.push({ name: 'issue', params: { issueId: id } })
        }).catch(() => {
          this.loading = false
        })
      }
    }
  }
</script>
